// Icons
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faInfoCircle, faListAlt, faUser } from "@fortawesome/free-solid-svg-icons";
// React Tools
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
// Custom Components
import PdmsNavbar from "components/navbars/PdmsNavbar";
import Popup from "../../components/Popup";
// Images
import { fetchPedagogicalTest, postMcqExamAnswers } from "services/pdms";
import toast from "react-hot-toast";
// Global Data
import { useAuth } from "context/AuthContext";

// Animated transitions (simple fade)
const fadeClass = "transition-opacity duration-500 ease-in-out";
// Stepper icons (cycle through for demo)
const stepIcons = [faListAlt, faUser, faInfoCircle];

const PdmsPedagogicalTest = () => {
    const { userInfo } = useAuth();
    const navigate = useNavigate();
    const [test, setTest] = useState({});
    const [submitted, setSubmitted] = useState(false);
    const [showReview, setShowReview] = useState(false);
    const [activeStep, setActiveStep] = useState(0);
    const [answers, setAnswers] = useState([]);
    const [openReviewSection, setOpenReviewSection] = useState(0);
    const [answeredCount, setAnsweredCount] = useState(0);

    useEffect(() => {
        const loadPedagogicalTest = async () => {
            const response = await fetchPedagogicalTest();
            setTest(response);
        }

        loadPedagogicalTest();
    }, []);

    useEffect(() => {
        setAnsweredCount(answers.length);
    }, [answers]);

    const selectAnswer = (questionId, choiceId) => {
        setAnswers((prev) => {
            const existing = prev.find(a => a.question_id === questionId);

            if (existing) {
                // update
                return prev.map(a =>
                    a.question_id === questionId
                        ? { ...a, choice_id: choiceId }
                        : a
                );
            }

            // add new
            return [...prev, { question_id: questionId, choice_id: choiceId }];
        });
    };

    const submitFormHandler = async (e) => {
        e.preventDefault()
        try {
            if (answers.length !== totalCount) {
                return toast.error('الرجاء الاجابة علي كل الاسئلة')
            }
            const formData = {
                user_id: userInfo.id,
                exam_id: 6,
                allAnswers: answers
            }
            await postMcqExamAnswers(formData);
            setSubmitted(true);
            navigate('/pdms');
        } catch (error) {
            toast.error("حدث خطا الرجاء المحاولة مرة اخري");
        }

    };

    // Review step: collect all answers
    const handleReview = (e) => {
        e.preventDefault();
        setShowReview(true);
    };

    // close submit popup and navigate to home page
    const closePopup = () => {
        setSubmitted(false)
        navigate('/pdms');
    };

    const totalCount = test?.fields?.reduce(
        (sum, obj) => sum + obj.questions.length,
        0
    );

    // const sectionEntries = Object.entries(filteredForm2[0]);
    // const sectionNames = sectionEntries.map(([name]) => name);
    const progress = totalCount ? Math.round((answeredCount / totalCount) * 100) : 0;
    return (
        <>
            <PdmsNavbar />
            <div className="w-full min-h-[86vh] flex flex-col justify-start items-center bg-gradient-to-br from-[#f7f8fa] to-[#e9eaf3]">
                {/* test navigator and progress bar */}
                <div className="w-full flex flex-col items-center sticky z-30 bg-white/90 shadow-md pb-4 border-b border-gray-200" style={{ backdropFilter: 'blur(8px)' }}>
                    {/* Progress Bar */}
                    <div className="w-[95%] h-3 bg-gray-200 rounded-full relative overflow-hidden">
                        <div className="h-full rounded-full bg-gradient-to-br from-[#181E41] to-[#F05A1A] transition-all duration-300" style={{ width: `${progress}%` }} />
                        <span className="absolute right-3 top-0 text-xs font-bold text-gray-700">{progress}%</span>
                    </div>
                    {/* field navigator */}
                    <div className="w-full mt-4">
                        <div className="flex items-center gap-2 overflow-x-auto whitespace-nowrap px-2 sm:overflow-visible sm:whitespace-normal sm:justify-center" dir="rtl">
                            {test?.fields?.map((field, idx) => (
                                <button
                                    key={field.name}
                                    onClick={() => { setActiveStep(idx); setShowReview(false); }}
                                    className={`relative px-4 py-2 rounded-full font-bold text-base transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-orange-200 ${activeStep === idx && !showReview ? 'bg-gradient-to-br from-[#181E41] to-[#F05A1A] text-white shadow-lg scale-105' : 'bg-white text-gray-800 hover:bg-orange-50'}`}
                                    style={{ fontFamily: 'Inter,sans-serif' }}
                                    aria-current={activeStep === idx && !showReview ? 'step' : undefined}
                                >
                                    <span className="flex items-center gap-2">
                                        <FontAwesomeIcon icon={stepIcons[idx % stepIcons.length]} className={`text-lg transition-all duration-300 ${activeStep === idx ? 'animate-bounce' : ''}`} />
                                        {field.name}
                                    </span>
                                </button>
                            ))}
                            <button
                                onClick={() => setShowReview(true)}
                                className={`px-4 py-2 rounded-full font-bold text-base transition-all duration-200 ml-4 ${showReview ? 'bg-gradient-to-br from-[#181E41] to-[#F05A1A] text-white shadow-lg scale-105' : 'bg-white text-gray-800 hover:bg-orange-50'}`}
                                style={{ fontFamily: 'Inter,sans-serif' }}
                                aria-current={showReview ? 'step' : undefined}
                            >
                                <span className="flex items-center gap-2">
                                    <FontAwesomeIcon icon={faCheckCircle} className="text-lg" />
                                    مراجعة وإرسال
                                </span>
                            </button>
                        </div>
                    </div>
                </div>

                {/* test questions */}
                <div className="w-full flex justify-center mt-8 mb-8">
                    <form className="w-[95%] flex flex-col gap-8 bg-white rounded-2xl shadow-xl border border-gray-200 px-10 py-8 animate-fadeIn relative" onSubmit={showReview ? submitFormHandler : handleReview}>

                        {/* Section Content or Review Step */}
                        {!showReview ? (
                            <div className={`w-full ${fadeClass}`} key={activeStep}>
                                <div className="mb-2">
                                    <div className="text-lg font-bold mb-2 px-2 py-1 rounded bg-gradient-to-br from-[#181E41] to-[#F05A1A] text-white shadow flex items-center gap-2" style={{ fontFamily: 'Inter,sans-serif' }} dir="rtl">
                                        <span>{test?.fields?.[activeStep]?.name}</span>
                                        <span className="ml-2 text-xs font-normal text-orange-100">{test?.fields?.[activeStep]?.questions?.length} سؤال</span>
                                        <span className="ml-2 text-xs text-white/80 cursor-pointer" title={'معلومات القسم'}>ℹ️</span>
                                    </div>
                                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" dir="rtl">
                                        {test?.fields?.[activeStep]?.questions?.map((question, index) => (
                                            <div
                                                key={question.id}
                                                className="bg-gradient-to-br from-[#f7f8fa] to-[#e9eaf3] rounded-xl shadow border border-gray-100 p-5 flex flex-col items-center min-h-[120px] transition-all duration-200 hover:shadow-xl hover:scale-[1.025] focus-within:ring-2 focus-within:ring-orange-300"
                                                tabIndex={0}
                                            >
                                                <h3 className="w-full text-base font-bold mb-4 text-gray-800 text-start" style={{ fontFamily: 'Inter,sans-serif' }}>
                                                    {question.name}
                                                </h3>
                                                <div className="flex flex-col justify-center gap-4 w-full">
                                                    {question?.choices?.map((answer) => {
                                                        const isSelected = answers.some(
                                                            a => a.question_id === question.id && a.choice_id === answer.id
                                                        );

                                                        return (
                                                            <div
                                                                key={answer.id}
                                                                onClick={() => selectAnswer(question.id, answer.id)}
                                                                className={`flex items-center gap-3 p-3 rounded-lg border cursor-pointer transition
                                                                ${isSelected
                                                                        ? 'border-orange-500 bg-orange-50'
                                                                        : 'border-gray-200 hover:border-orange-400 hover:bg-orange-50'
                                                                    }
                                                                `}
                                                            >
                                                                {/* radio */}
                                                                <div className="w-5 h-5 rounded-full border-2 border-gray-400 flex items-center justify-center">
                                                                    {isSelected && (
                                                                        <div className="w-2.5 h-2.5 rounded-full bg-orange-500" />
                                                                    )}
                                                                </div>

                                                                <span className="text-gray-800 font-medium">
                                                                    {answer.name}
                                                                </span>
                                                            </div>
                                                        );
                                                    })}

                                                </div>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        ) : (
                            // Review Step
                            <div className="w-full animate-fadeIn">
                                <div className="text-lg font-bold mb-4 px-2 py-1 rounded bg-gradient-to-br from-[#181E41] to-[#F05A1A] text-white shadow flex items-center gap-2" style={{ fontFamily: 'Inter,sans-serif' }}>
                                    راجع إجاباتك قبل الإرسال:
                                </div>
                                <div className="flex flex-col gap-4">
                                    {test?.fields?.map((field, idx) => (
                                        <div key={field.id} className="border rounded-xl shadow bg-white">
                                            <button
                                                type="button"
                                                className={`w-full flex justify-between items-center px-6 py-4 text-lg font-bold rounded-t-xl focus:outline-none transition-colors ${openReviewSection === idx ? 'bg-gradient-to-br from-[#181E41] to-[#F05A1A] text-white' : 'bg-gray-100 text-gray-800 hover:bg-orange-50'}`}
                                                onClick={() => setOpenReviewSection(openReviewSection === idx ? -1 : idx)}
                                                style={{ fontFamily: 'Inter,sans-serif' }}
                                            >
                                                <span>{field.name}</span>
                                                <span className="text-sm font-normal">
                                                    {field.questions.filter(q => answers[`question:${q.question_id}`] !== undefined && answers[`question:${q.question_id}`] !== null).length}
                                                    {" / "}
                                                    {field.questions.length} {'سؤال'}
                                                </span>
                                            </button>
                                            {openReviewSection === idx && (
                                                <div className="px-6 py-4 flex flex-col gap-2">
                                                    {field.questions.map((question) => {
                                                        const score = answers.find(answer => answer.question_id === question.id);
                                                        return (
                                                            <div key={field.questions.id} className="flex justify-between items-center border-b py-2 last:border-b-0">
                                                                <span className="text-gray-800 font-semibold">{question.name}</span>
                                                                <span className="text-gray-700 font-bold">
                                                                    {score !== null && score !== undefined
                                                                        ? <span className="text-green-600">تم الإجابة عليه</span>
                                                                        : <span className="text-red-500">لم يتم الإجابة</span>}
                                                                </span>
                                                            </div>
                                                        );
                                                    })}
                                                    <div className="flex justify-end mt-2">
                                                        <button
                                                            type="button"
                                                            className="px-4 py-2 rounded-full bg-gradient-to-br from-[#181E41] to-[#F05A1A] text-white font-bold shadow hover:scale-105 transition-all"
                                                            onClick={() => { setActiveStep(idx); setShowReview(false); }}
                                                        >
                                                            تعديل القسم
                                                        </button>
                                                    </div>
                                                </div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        )}

                        {/* Sticky Action Bar for Navigation/Submit */}
                        <div className="fixed bottom-8 left-0 w-full flex justify-center z-50 pointer-events-none">
                            <div className="flex gap-4 pointer-events-auto">
                                {!showReview && (
                                    <>
                                        <button
                                            type="button"
                                            className="px-8 py-3 rounded-2xl text-white font-bold text-lg shadow-lg bg-gradient-to-br from-[#181E41] to-[#F05A1A] hover:from-[#181E41] hover:to-orange-600 transition-all duration-200 focus:outline-none focus:ring-4 focus:ring-orange-200"
                                            onClick={() => setActiveStep((s) => Math.max(0, s - 1))}
                                            disabled={activeStep === 0}
                                        >
                                            السابق
                                        </button>
                                        {activeStep < test?.fields?.length - 1 && (
                                            <button
                                                type="button"
                                                className="px-8 py-3 rounded-2xl text-white font-bold text-lg shadow-lg bg-gradient-to-br from-[#181E41] to-[#F05A1A] hover:from-[#181E41] hover:to-orange-600 transition-all duration-200 focus:outline-none focus:ring-4 focus:ring-orange-200"
                                                onClick={() => setActiveStep((s) => Math.min(test?.fields?.length - 1, s + 1))}
                                            >
                                                التالي
                                            </button>
                                        )}
                                        {activeStep === test?.fields?.length - 1 && (
                                            <button
                                                type="button"
                                                className="px-8 py-3 rounded-2xl text-white font-bold text-lg shadow-lg bg-gradient-to-br from-[#181E41] to-[#F05A1A] hover:from-[#181E41] hover:to-orange-600 transition-all duration-200 focus:outline-none focus:ring-4 focus:ring-orange-200"
                                                onClick={handleReview}
                                            >
                                                مراجعة وإرسال
                                            </button>
                                        )}
                                    </>
                                )}
                                {showReview && (
                                    <button
                                        id="final-submit-btn"
                                        type="submit"
                                        className="px-10 py-4 rounded-2xl text-white font-bold text-xl shadow-2xl bg-gradient-to-br from-[#181E41] to-[#F05A1A] hover:from-[#181E41] hover:to-orange-600 transition-all duration-200 focus:outline-none focus:ring-4 focus:ring-orange-200 animate-fadeIn"
                                    >
                                        أرسال
                                    </button>
                                )}
                            </div>
                        </div>
                    </form>
                </div>
                <Popup
                    isOpen={submitted}
                    onClose={closePopup}
                    message={"تم تسجيل تقييمك بنجاح"}
                />
            </div>
        </>
    )
}

export default PdmsPedagogicalTest;